import Grid from '@mui/material/Grid';

export const FiltersSectionWrapper = ({ components }) => {
  if (components?.length === 0) {
    return null;
  }

  return (
    <Grid container>
      <Grid size={{ xs: 12, md: 8 }} spacing={1}>
        {components?.map((item, index) => (
          <Grid size={12} key={`${index}-filters-section-wrapper`}>
            {item}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
